import { BoxProgramVisibility } from "@/modules/boxProgrammation/boxProgramTypes"
import { ProgramType } from "@/modules/programs/types/programTypes"
import { MAX_255_CHARACTERS, MAX_65535_CHARACTERS } from "@/typings/formik"
import { BoxOfferItemDtoSchema } from "@modules/boxOffer/gateway/boxOfferDto"
import { HUImageDtoSchema } from "@modules/dtos/imageDto"
import { UserDtoSchema } from "@modules/profile/userProfile/userDto"
import { z } from "zod"

export const BoxProgramItemDtoSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    image: HUImageDtoSchema.nullable(),
    owner: UserDtoSchema,
    color: z.string(),
    type: z.enum(ProgramType),
    visibility: z.enum(BoxProgramVisibility).nullable(),
  })
  .meta({ id: "BoxProgramItemDtoSchema" })

export type BoxProgramItemDto = z.infer<typeof BoxProgramItemDtoSchema>

export const BoxProgramDetailsDtoSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    description: z.string(),
    image: HUImageDtoSchema.nullable(),
    owner: UserDtoSchema.nullable(),
    boxId: z.string(),
    color: z.string(),
    type: z.enum(ProgramType),
    visibility: z.enum(BoxProgramVisibility).nullable(),
    defaultHideSessionContent: z.boolean(),
    restrictions: BoxOfferItemDtoSchema.array(),
  })
  .meta({ id: "BoxProgramDetailsDtoSchema" })

export type BoxProgramDetailsDto = z.infer<typeof BoxProgramDetailsDtoSchema>

export const CreateBoxProgramInputDtoSchema = z
  .object({
    name: z.string().max(MAX_255_CHARACTERS),
    description: z.string().max(MAX_65535_CHARACTERS),
    imageKey: z.string().nullable(),
    color: z.string().nullable(),
    defaultHideSessionContent: z.boolean(),
    visibility: z.enum(BoxProgramVisibility).nullable(),
    offerIds: z.array(z.string()).nullable(),
  })
  .meta({ id: "CreateBoxProgramInputDtoSchema" })

export type CreateBoxProgramInputDto = z.infer<typeof CreateBoxProgramInputDtoSchema>

export const UpdateBoxProgramInputDtoSchema = z
  .object({
    name: z.string().nullable(),
    description: z.string().nullable(),
    imageKey: z.string().nullable(),
    color: z.string().nullable(),
    defaultHideSessionContent: z.boolean(),
    visibility: z.enum(BoxProgramVisibility).nullable(),
    offerIds: z.array(z.string()).nullable(),
  })
  .meta({ id: "UpdateBoxProgramInputDtoSchema" })

export type UpdateBoxProgramInputDto = z.infer<typeof UpdateBoxProgramInputDtoSchema>

export const BoxProgrammationLightSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    color: z.string(),
    defaultHideSessionContent: z.boolean(),
    visibility: z.enum(BoxProgramVisibility).nullable(),
  })
  .meta({ id: "BoxProgrammationLightSchema" })

export type BoxProgrammationLight = z.infer<typeof BoxProgrammationLightSchema>
